import { BrandMark } from "@diffex/ui";

import { submitLogout, type SessionIdentity } from "../auth";

type DashboardProps = {
  session: SessionIdentity;
};

export function Dashboard({ session }: DashboardProps) {
  const fullName = [session.user.first_name, session.user.last_name].filter(Boolean).join(" ");
  const displayName = fullName || session.user.email;

  return (
    <div className="product-shell">
      <header className="product-header">
        <BrandMark className="product-brand" />
        <div className="identity-menu">
          <span className="identity-org">{session.organization.name || "Personal workspace"}</span>
          <button
            className="logout-button"
            type="button"
            onClick={() => submitLogout(session.csrf_token)}
          >
            Sign out
          </button>
        </div>
      </header>
      <main className="dashboard-main">
        <section className="dashboard-intro" aria-labelledby="dashboard-title">
          <p className="eyebrow">Workspace</p>
          <h1 id="dashboard-title">Welcome, {displayName}</h1>
          <p>
            Your Diffex identity is connected and ready. Product sessions will appear here when
            they are enabled for your organization.
          </p>
        </section>
        <section className="identity-card" aria-labelledby="identity-title">
          <div>
            <p className="eyebrow">Authenticated identity</p>
            <h2 id="identity-title">{session.organization.name || "Personal workspace"}</h2>
          </div>
          <dl>
            <div>
              <dt>User</dt>
              <dd>{session.user.email}</dd>
            </div>
            <div>
              <dt>Membership</dt>
              <dd>{session.membership.role}</dd>
            </div>
            <div>
              <dt>Status</dt>
              <dd>
                <span className="status-dot" aria-hidden="true" />
                {session.membership.status}
              </dd>
            </div>
          </dl>
        </section>
      </main>
    </div>
  );
}
